import bg1024 from '../../../../../assets/hero_bottom_bg1024.png';
import bg1200 from '../../../../../assets/hero_bottom_bg1200.png';
import bg1400 from '../../../../../assets/hero_bottom_bg1400.png';
import bg1920 from '../../../../../assets/hero_bottom_bg1920.png';
import bg360 from '../../../../../assets/hero_bottom_bg360.png';
import bg414 from '../../../../../assets/hero_bottom_bg414.png';
import bg576 from '../../../../../assets/hero_bottom_bg576.png';
import bg768 from '../../../../../assets/hero_bottom_bg768.png';
import bg992 from '../../../../../assets/hero_bottom_bg992.png';
import skyBg1400 from '../../../../../assets/lightning-sky_bg1400.png';
import skyBg1920 from '../../../../../assets/lightning-sky_bg1920.png';
import skyBg360 from '../../../../../assets/lightning-sky_bg360.png';
import skyBg414 from '../../../../../assets/lightning-sky_bg414.png';
import skyBg576 from '../../../../../assets/lightning-sky_bg576.png';
import skyBg768 from '../../../../../assets/lightning-sky_bg768.png';
import skyBg992 from '../../../../../assets/lightning-sky_bg992.png';

import './styles.scss';

/**
 * Layered sky and ground artwork behind the lightning hero.
 */
export const LightningHeroBackgrounds = () => (
    <div className='lightning-hero-backgrounds'>
        <div className='lightning-hero-backgrounds__sky'>
            <picture>
                <source media='(min-width: 1920px)' srcSet={skyBg1920} />
                <source media='(min-width: 1400px)' srcSet={skyBg1400} />
                <source media='(min-width: 992px)' srcSet={skyBg992} />
                <source media='(min-width: 768px)' srcSet={skyBg768} />
                <source media='(min-width: 576px)' srcSet={skyBg576} />
                <source media='(min-width: 414px)' srcSet={skyBg414} />
                <img
                    fetchPriority='high'
                    width={618}
                    height={998}
                    src={skyBg360}
                    alt='Hero Background'
                />
            </picture>
        </div>
        <div className='lightning-hero-backgrounds__ground'>
            <picture>
                <source srcSet={bg1920} media='(min-width: 1920px)' />
                <source srcSet={bg1400} media='(min-width: 1400px)' />
                <source srcSet={bg1200} media='(min-width: 1200px)' />
                <source srcSet={bg1024} media='(min-width: 1024px)' />
                <source srcSet={bg992} media='(min-width: 992px)' />
                <source srcSet={bg768} media='(min-width: 768px)' />
                <source srcSet={bg576} media='(min-width: 576px)' />
                <source srcSet={bg414} media='(min-width: 414px)' />
                <img
                    src={bg360}
                    width={360}
                    height={424}
                    alt='Hero Background'
                />
            </picture>
        </div>
    </div>
);
